import { GenericListItemsStack, type GenericListItemsStackProps } from './GenericListItemsStack';

export interface GenericMenuListItemsStackProps extends GenericListItemsStackProps {}

export const GenericMenuListItemsStack = ({
  children,
  gap = 0,
  ref,
  ...props
}: GenericMenuListItemsStackProps) => (
  <GenericListItemsStack
    role='menu'
    tabIndex={-1}
    {...props}
    aria-label={props['aria-label'] ?? 'dropdown menu'}
    gap={gap}
    ref={ref}
  >
    {children}
  </GenericListItemsStack>
);
